var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItsmarcosjreyesHeaderSmallWamhLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "630px",
    height: "630px",
    viewBox: "0 0 630 630",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "itsmarcosjreyes-header-small-wamh-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "itsmarcosjreyes-header-small-wamh-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 153.000000)",
    fill: "#FFFFFF",
    stroke: "#FF5B00",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505,58 L599.968391,58 C608.65613,92.1666667 613,126.333333 613,160.5 C613,194.666667 608.65613,228.833333 599.968391,263 L505,263 C513.68774,229.600729 518.031609,195.690954 518.031609,161.270677 C518.031609,126.850399 513.68774,92.4268402 505,58 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,0 L534.03011,0 C544.010037,53.8333333 549,107.666667 549,161.5 C549,215.333333 544.010037,269.166667 534.03011,323 L479,323 C488.979926,270.375782 493.96989,216.947211 493.96989,162.714286 C493.96989,108.481361 488.979926,54.2432653 479,0 Z",
    id: "Rectangle",
    transform: "translate(514.000000, 161.500000) scale(-1, 1) translate(-514.000000, -161.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,34 L509.462639,34 C524.487546,76.5 532,119 532,161.5 C532,204 524.487546,246.5 509.462639,289 L89,289 C104.024907,247.454565 111.537361,205.274114 111.537361,162.458647 C111.537361,119.643179 104.024907,76.8236305 89,34 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494,0 L549.03011,0 C559.010037,53.8333333 564,107.666667 564,161.5 C564,215.333333 559.010037,269.166667 549.03011,323 L494,323 C503.979926,270.375782 508.96989,216.947211 508.96989,162.714286 C508.96989,108.481361 503.979926,54.2432653 494,0 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,0 L123.891555,0 C135.297185,53.8333333 141,107.666667 141,161.5 C141,215.333333 135.297185,269.166667 123.891555,323 L61,323 C72.4056302,270.375782 78.1084453,216.947211 78.1084453,162.714286 C78.1084453,108.481361 72.4056302,54.2432653 61,0 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 61.5,
    cy: 161.5,
    rx: 23.5,
    ry: 161.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,58 L59.4493814,58 C65.8164605,92.1666667 69,126.333333 69,160.5 C69,194.666667 65.8164605,228.833333 59.4493814,263 L13,263 C19.3670791,229.600729 22.5506186,195.690954 22.5506186,161.270677 C22.5506186,126.850399 19.3670791,92.4268402 13,58 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.5,
    cy: 160.5,
    rx: 13.5,
    ry: 102.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,34 L415.82381,34 C427.274603,76.5 433,119 433,161.5 C433,204 427.274603,246.5 415.82381,289 L215,289 C226.450793,247.454565 232.17619,205.274114 232.17619,162.458647 C232.17619,119.643179 226.450793,76.8236305 215,34 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.347511,34.0001256 C491.782504,76.6029675 497,119.205809 497,161.808651 C497,180.538944 495.991504,199.269237 493.974512,217.999529 L442.361981,217.999665 C444.3068,199.708287 445.27921,181.298271 445.27921,162.769618 C445.27921,120.364153 440.185841,77.9546939 429.999102,35.5412407 L430.011102,34 L481.347511,34.0001256 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.253034,273 L159,273 C163.707102,246.637806 166.635829,219.971144 167.786181,193.000013 L276.999968,193.000726 C275.823159,219.667151 272.907514,246.333575 268.253034,273 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.3970588,
    y1: 39.5,
    x2: 132.602941,
    y2: 39.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.3985507,
    y1: 88.5,
    x2: 137.601449,
    y2: 88.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.4,
    y1: 137.5,
    x2: 140.6,
    y2: 137.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.4,
    y1: 184.5,
    x2: 140.6,
    y2: 184.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.3985507,
    y1: 237.5,
    x2: 137.601449,
    y2: 237.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.3970588,
    y1: 285.5,
    x2: 131.602941,
    y2: 285.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 501.398551,
    y1: 39.5,
    x2: 555.601449,
    y2: 39.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.398551,
    y1: 88.5,
    x2: 560.601449,
    y2: 88.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.398551,
    y1: 137.5,
    x2: 563.601449,
    y2: 137.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.398551,
    y1: 184.5,
    x2: 563.601449,
    y2: 184.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.398551,
    y1: 237.5,
    x2: 560.601449,
    y2: 237.5,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 499.398551,
    y1: 285.5,
    x2: 553.601449,
    y2: 285.5,
    id: "Line",
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItsmarcosjreyesHeaderSmallWamhLogo);
export default __webpack_public_path__ + "static/media/itsmarcosjreyes-header-small-wamh-logo.9b8d043c3e9306b5e2e98a8d137c42c7.svg";
export { ForwardRef as ReactComponent };